const checkNestedProperties = (function(window) {

    /**
     * Check for the existence of nested variables - for instance in themeSettings in theme.php are some vars you would like to use in a nested setting
     */

    function nestedPropertyExists(obj /*, level1, level2, ... levelN*/) {
        let args = Array.prototype.slice.call(arguments, 1);
        for (var i = 0; i < args.length; i++) {
            if (!obj || !obj.hasOwnProperty(args[i])) { 
                return false;
            }
            obj = obj[args[i]];
        }
        return true;
    }

    return {
        exist: nestedPropertyExists
    };

}(window));

export { checkNestedProperties };